<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity" :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter" :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesInventoryMaterialQuantityResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                    with-custom-row-actions-first-column editDisable
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity" :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter" :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-adjust"
                                        :disabled="actionDisabled('selectOne')"
                                        custom-label="盘点"
                                        :showName="true"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        @click="openAdjustDialog()"
                                    >
                                    </em-button>
                                    <b-button
                                    variant="outline-primary"
                                    size="sm"
                                    :disabled="actionDisabled('selectOne')"
                                    @click="openInputDialog()"
                                    >
                                    入库
                                    </b-button>
                                    <b-button
                                    variant="outline-primary"
                                    size="sm"
                                    :disabled="actionDisabled('selectOne')"
                                    @click="openOutputDialog()"
                                    >
                                    出库
                                    </b-button>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <b-button
                                            variant="outline-primary"
                                            size="sm"
                                            @click="gotoAdjustRecord(customRowScope.row)"
                                        >
                                            盘点记录
                                        </b-button>
                                        <b-button
                                            variant="outline-primary"
                                            size="sm"
                                            @click="gotoOutputInputRecord(customRowScope.row)"
                                        >
                                            出入库记录
                                        </b-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="库存调差" width="30%" :visible.sync="adjustDialogVisible" :close-on-click-modal='false' append-to-body @close='clearAdjustQuantity'>
            <el-form :model="adjustForm" ref="adjustForm" label-width="auto">
                <el-form-item label="实际库存">
                    <el-input v-model="adjustForm.adjustQuantity" type="number"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="adjustDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAdjust()" :disabled="checkAdjustQuantity()">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog title="入库" width="30%" :visible.sync="inputDialogVisible" :close-on-click-modal='false' append-to-body @close='clearInputQuantity'>
            <el-form :model="inputForm" ref="inputForm" label-width="auto" :rules="inputRules">
                <el-form-item label="入库量(t)" prop="inputQuantity">
                    <el-input v-model="inputForm.inputQuantity" type="number"></el-input>
                </el-form-item>
                <el-form-item label="入库时间" prop="inputTime">
                    <el-date-picker v-model="inputForm.inputTime" type="datetime" placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="inputDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="materialIncoming()" :disabled="disableInput">确认</el-button>
            </div>
        </el-dialog>
        <el-dialog title="出库" width="30%" :visible.sync="outputDialogVisible" :close-on-click-modal='false' append-to-body @close='clearOutputQuantity'>
            <el-form :model="outputForm" ref="outputForm" label-width="auto" :rules="outputRules">
                <el-form-item label="出库量(t)" prop="outputQuantity">
                    <el-input v-model="outputForm.outputQuantity" type="number"></el-input>
                </el-form-item>
                <el-form-item label="出库时间" prop="outputTime">
                    <el-date-picker v-model="outputForm.outputTime" type="datetime" placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="outputDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="materialExport()" :disabled="disableOutput">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-10-20 16:53:01

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import commonViewsUtil from "@/utils/commonViewsUtil";
    import emCommonGotoMixin from "@/mixin/em/common/goto";

    export default {
        name: "mintalMesInventoryMaterialQuantityListView",
        mixins: [emCommonListMixin,emCustomVuexMixin,emCommonApiMixin,commonViewsUtil,emCommonGotoMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                adjustDialogVisible: false,
                inputDialogVisible: false,
                outputDialogVisible: false,
                adjustForm: {
                    adjustQuantity:''
                },
                inputForm: {
                    inputQuantity:'',
                    inputTime: ''
                },
                outputForm: {
                    outputQuantity: '',
                    outputTime: ''
                },
                inputRules: {
                    inputQuantity: [{required: true, message: '入库量不能为空'}],
                    inputTime: [{required: true, message: '入库时间不能为空'}]
                },
                outputRules: {
                    outputQuantity: [{required: true, message: '出库量不能为空'}],
                    outputTime: [{required: true, message: '出库时间不能为空'}]
                },
            }
        },
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            },
            checkedItems() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItems"];
            },
            selectIds() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItems"].join(",");
            },
            disableInput() {
                if(this.inputForm.inputQuantity <= 0 ) {
                    return true;
                }

                return false;
            },
            disableOutput() {
                if(this.outputForm.outputQuantity <= 0) {
                    return true;
                }

                return false;
            }
        },
        methods: {
            actionDisabled(type) {
                    // 删除按钮在一条记录都没选的时候禁用
                if (type === "select") {
                        return this.checkedItems && this.checkedItems.length === 0;
                }
                    // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
                else if (type === "selectOne") {
                    return this.checkedItems && this.checkedItems.length !== 1;
                }
            },
            openAdjustDialog() {
                this.adjustDialogVisible = true;
            },
            openInputDialog() {
                this.inputDialogVisible = true;
            },
            openOutputDialog() {
                this.outputDialogVisible = true;
            },
            checkAdjustQuantity() {
                //盘点调差允许调为0
                if(this.adjustForm.adjustQuantity >= 0) {
                    return false;
                }
                return true;
            },
            confirmAdjust() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/adjustMaterialQuantity?id=${this.selectIds}&quantity=${self.adjustForm.adjustQuantity}`
                self.$_emApiMixin_post(url, {})
                .then(response => {
                    if (response.status === 200) {
                            self.$message({
                            message: "调差成功",
                            type: "success",
                            });

                            self.$refs.emListFilter.doQuery();
                        } else {
                            self.$message({
                            message: "调差失败",
                            type: "error",
                            });
                        }
                })
                .finally(() => this.adjustDialogVisible = false)
            },
            clearAdjustQuantity() {
                this.adjustForm.adjustQuantity = null;
            },
            clearInputQuantity() {
                this.inputForm.inputQuantity = '',
                this.inputForm.inputTime = '',
                this.$refs["inputForm"].resetFields();
            },
            clearOutputQuantity() {
                this.outputForm.outputQuantity = '',
                this.outputForm.outputTime = '',
                this.$refs["outputForm"].resetFields();
            },
            materialIncoming() {
                let self = this;
                self.$refs["inputForm"].validate(valid => {
                    if(valid) {
                        let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/materialIncoming?id=${this.selectIds}&quantity=${self.inputForm.inputQuantity}&time=${self.inputForm.inputTime}`
                        self.$_emApiMixin_post(url, {})
                        .then(response => {
                            if (response.status === 200) {
                                    self.$message({
                                    message: "入库成功",
                                    type: "success",
                                    });

                                    self.$refs.emListFilter.doQuery();
                                } else {
                                    self.$message({
                                    message: "入库失败",
                                    type: "error",
                                    });
                                }
                        })
                        .finally(() => this.inputDialogVisible = false)
                    } else {
                        self.$message({
                            message: "数据不完整",
                            type: "error",
                        });
                        return;
                    }
                })
            },
            materialExport() {
                let self = this;
                self.$refs["outputForm"].validate(valid => {
                    if(valid) {
                        let url = `${this.$_emApiMixin_entityBaseApi(self.modelName)}/materialExport?id=${this.selectIds}&quantity=${self.outputForm.outputQuantity}&time=${self.outputForm.outputTime}`
                        self.$_emApiMixin_post(url, {})
                        .then(response => {
                            if (response.status === 200) {
                                    self.$message({
                                    message: "出库成功",
                                    type: "success",
                                    });

                                    self.$refs.emListFilter.doQuery();
                                } else {
                                    self.$message({
                                    message: "出库失败",
                                    type: "error",
                                    });
                                }
                        })
                        .finally(() => this.outputDialogVisible = false)
                    } else {
                        self.$message({
                            message: "数据不完整",
                            type: "error",
                        });
                        return;
                    }
                })

            },
            gotoAdjustRecord(row) {
                this.$_emGotoMixin_gotoHolderList("mintalMesInventoryQuantityAdjustment"
                    , {materialQuantityIdFilter: row.id}
                    , {materialQuantityId: row.id}, false, {})
            },
            gotoOutputInputRecord(row) {
                this.$_emGotoMixin_gotoHolderList("mintalMesInventoryInputOutput"
                    , {materialIdFilter: row.materialId,warehouseIdFilter:row.warehouseId,orderCodeFilter:row.orderCode,gradeFilter:row.grade}
                    , {materialId: row.materialId,warehouseId:row.warehouseId,orderCode:row.orderCode,grade:row.grade}, false, {})
            }
        }
    };
</script>
